import React from 'react'
import { Router, NavigateFn } from '@reach/router'
import Appbar from 'components/Appbar'
import TableView from './TableView'
import Search from './Search'
import useTickets from './hooks/useTickets'
import { useTrackNavigate } from '@hooks'
import { navigateWithBasepath } from 'App'
import { ModalLayer, PageContent } from '@ui'

export default function TicketManagement({
  navigate,
  location,
}: {
  navigate: NavigateFn
  location: Location
}) {
  useTrackNavigate()
  const tickets = useTickets()

  return (
    <>
      <Appbar title="Tickets">
        <Search {...{ navigate, queryTable: tickets.queryTable }} />
      </Appbar>
      <PageContent>
        <TableView navigate={navigate} tickets={tickets} location={location} />
      </PageContent>
      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
      {/* @ts-ignore */}
      <Router primary={false} navigate={navigateWithBasepath}>
        <ModalLayer path="*" reload={tickets.reload} />
      </Router>
    </>
  )
}
